import classNames from 'classnames';
import {NOTIFICATION_TYPES} from 'services/interfaces/global-interfaces';
import 'scss/ui3/notification-template.scss';
import React from 'react';

interface IDefaultNotification {
  icon: string;
}

interface INotificationProps {
  type: string;
  onCloseClick: VoidFunction;
  children?: React.ReactNode;
}

const NOTIFICATIONS: Record<NOTIFICATION_TYPES, IDefaultNotification> = {
  [NOTIFICATION_TYPES.Warning]: {
    icon: 'warn fas fa-exclamation-triangle',
  },
  [NOTIFICATION_TYPES.Info]: {
    icon: 'info fas fa-info-circle',
  },
  [NOTIFICATION_TYPES.Help]: {
    icon: 'info fas fa-info-circle',
  },
  [NOTIFICATION_TYPES.Error]: {
    icon: 'error fas fa-exclamation-triangle',
  },
  [NOTIFICATION_TYPES.Success]: {
    icon: 'success fas fa-check-circle',
  },
  [NOTIFICATION_TYPES.Confirm]: {
    icon: 'confirm fas fa-info-circle',
  },
  [NOTIFICATION_TYPES.Prompt]: {
    icon: 'prompt fa-duotone fa-terminal',
  },
  [NOTIFICATION_TYPES.Custom]: {icon: ''},
} as const;

function NotificationPanel(props: INotificationProps): JSX.Element {
  return (
    <div className={classNames('notification', `notification__${props.type}`)}>
      <div className={'notification__content-container'}>
        <div className='notification__icon-container'>
          <i className={classNames('notification__icon', NOTIFICATIONS[props.type as NOTIFICATION_TYPES].icon)} />
        </div>

        <div className={'notification__content'}>{props.children}</div>

        <div className='notification__close-container'>
          <i className={'fal fa-times'} onClick={props.onCloseClick} />
        </div>
      </div>
    </div>
  );
}

export default NotificationPanel;
